import Api from '../api';
import { isEmpty as _isEmpty, omitBy as _omitBy } from 'lodash-es';
import QueryString from 'query-string';

export default class AccountApi extends Api {
  getAccountData = async () => {
    try {
      const { data } = await this.get(`/getNickName`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  getTopSoldStores = async queryParams => {
    try {
      const omittedPayload = _omitBy(queryParams, _isEmpty);
      const queryObj = QueryString.stringify(omittedPayload) || '';
      const { data } = await this.get(`/orders/summary?${queryObj}`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  getLinkedWMSData = async () => {
    try {
      const { data } = await this.get(`/wms/channels`);
      return { data };
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  getTopSoldSellerSKU = async (queryParams, channel) => {
    const omittedPayload = _omitBy(queryParams, _isEmpty);
    const queryObj = QueryString.stringify(omittedPayload) || '';
    try {
      return await this.get(`dashboard/topSoldSKU?${queryObj}`);
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };

  initiateChannel = async (channel, payload) => {
    try {
      const apiData = await this.post(`linkAccount/initiate/` + channel, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  callDataMoatAPI = (url, payload) => {
    try {
      return this.post(url, payload);
    } catch (error) {
      return {
        hasError: true,
        error: error.response
      };
    }
  };

  getDataMoatRiskResponse = queryParams => {
    try {
      return this.get(`dataMoat/computeRisk?${queryParams}`);
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };

  getCalenderEvents = () => {
    try {
      return this.get('accountSettings/calendarEvents');
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };
}
